<h1 class="title-center py-3">Admin Dashboard</h1>

@if (!haveReports || !reportList) {
  <div class="empty_spacing_for_norecords">
    @if(gettingReports){
      <div>
        <app-lt-spinner></app-lt-spinner>
      </div>
    }
    @if (!gettingReports && !reportList) {
      <div class="no-records-message">No reports found.</div>
    }
  </div>
}

@if (reportList && haveReports) {
  <div class="container-fluid">
    @if (reportList !== undefined) {
      <div class="row row-cols-1 row-cols-lg-2">
        @for (r of reportList; track r) {
          <div class="col mb-4" (click)="selectReport(r)" (keydown.enter)="selectReport(r)">
            <div class="card">
              <div class="card-header bg-secondary text-white">{{r.title}}</div>
              <div class="card-body w-75">{{r.description}}</div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

<div class="container-fluid">
  <div class="row row-cols-1 row-cols-lg-2">
    <div class="col mb-4" (click)="goToCustomSQL()" (keydown.enter)="goToCustomSQL()">
      <div class="card">
        <div class="card-header bg-secondary text-white">Custom SQL Query Mappings</div>
        <div class="card-body w-75">Get Custom SQL Query Mappings</div>
      </div>
    </div>
    <div class="col mb-4" (click)="goToIntegrationMaintenance()" (keydown.enter)="goToIntegrationMaintenance()">
      <div class="card">
        <div class="card-header bg-secondary text-white">Integration Maintenance</div>
        <div class="card-body w-75">View, Update, and Create Integration Maintenance</div>
      </div>
    </div>
    <div class="col mb-4" (click)="goToDemoHome()" (keydown.enter)="goToDemoHome()">
      <div class="card">
        <div class="card-header bg-secondary text-white">LOS Talker Demo</div>
        <div class="card-body w-75">LOS Talker Demo Examples</div>
      </div>
    </div>
    <div class="col mb-4" (click)="goToInvoicingMetricsReportV2()" (keydown.enter)="goToInvoicingMetricsReportV2()">
      <div class="card">
        <div class="card-header bg-secondary text-white">Invoicing Metrics Report V2 (Legacy)</div>
        <div class="card-body w-75">Previous invoice period metrics report, replaced by the Contract Metrics Export in the Invoicing menu</div>
      </div>
    </div>
  </div>
</div>
